export const useBackNavigation = () => {
  const { $router } = useNuxtApp();

  if (!$router?.options?.history?.state?.back) {
    $router.go('/');
  } else {
    $router.back();
  }
};
